import { PaymentMethodType } from '../../../enums/paymentMethodType'
import { PaymentMethod } from '../../../types/paymentMethod'
import { PaymentMethodsForm } from '../elements/PaymentMethodsModal/types/PaymentMethodsForm'

const editablePaymentMethodTypes = new Set<PaymentMethodType>([
  PaymentMethodType.IBAN,
  PaymentMethodType.OTHER,
  PaymentMethodType.PAYPAL,
])

export const getPaymentMethodsPayload = (
  paymentMethods: PaymentMethod[],
  formValues: PaymentMethodsForm,
): PaymentMethod[] => {
  const ibanPaymentMethod = paymentMethods.find((method) => method.type === PaymentMethodType.IBAN)
  const otherPaymentMethod = paymentMethods.find((method) => method.type === PaymentMethodType.OTHER)
  const paypalPaymentMethod = paymentMethods.find((method) => method.type === PaymentMethodType.PAYPAL)
  const updatedPaymentMethods: PaymentMethod[] = []

  const hasAnyIbanFormValues = !!(formValues.bank || formValues.iban || formValues.swift)

  if (hasAnyIbanFormValues) {
    updatedPaymentMethods.push({
      ...ibanPaymentMethod,
      type: PaymentMethodType.IBAN,
      fields: {
        bank: formValues.bank ?? '',
        iban: formValues.iban ?? '',
        swift: formValues.swift ?? '',
      },
    })
  }

  if (formValues.paypalEmail === undefined && paypalPaymentMethod) {
    updatedPaymentMethods.push(paypalPaymentMethod)
  }

  if (formValues.paypalEmail) {
    updatedPaymentMethods.push({
      ...paypalPaymentMethod,
      type: PaymentMethodType.PAYPAL,
      fields: {
        paypal: formValues.paypalEmail,
      },
    })
  }

  if (formValues.offlinePayment === undefined && otherPaymentMethod) {
    updatedPaymentMethods.push(otherPaymentMethod)
  }

  if (formValues.offlinePayment) {
    updatedPaymentMethods.push({
      ...otherPaymentMethod,
      type: PaymentMethodType.OTHER,
      fields: {
        free: formValues.offlinePayment,
      },
    })
  }

  // IBAN, PayPal, and OTHER are the only types this UI edits. Keep every other cached method
  // (e.g. SWISH, BANKGIRO) so a save cannot drop country-specific methods we do not support yet.
  const preservedPaymentMethods = paymentMethods.filter((method) => !editablePaymentMethodTypes.has(method.type))

  return [...updatedPaymentMethods, ...preservedPaymentMethods]
}
